import {AppConfig} from '../types/AppConfig';

export const defaultAppConfig: AppConfig = {
  environmentName: 'local',
  siteName: 'Vården.se',
  baseUrl: 'https://new-dev.varden.se/',
  wpBackend: 'https://new-dev.varden.se/cms-data/',
  apiUrl: 'https://new-dev.varden.se/api/',
  wordpressApiUrl: 'https://new-dev.varden.se/cms-data/wp-json/wp/v2/',
  wordpressMenusApiUrl: 'https://new-dev.varden.se/cms-data/wp-json/menus/v1/',
  pageSize: 30,
  articlesPageSize: 10,
  amazonS3Url: 'https://new-dev.varden.se/gho-images/',
  amazonS3ContentUrl: 'https://varden-website-content.s3.eu-north-1.amazonaws.com/',
  amazonS3WpUrl: 'https://varden-wordpress.s3.eu-west-1.amazonaws.com/',
  googleMapsApiKey: 'AIzaSyC4ZTvBDHpsv5JlgdQBa2_NeKhwR1TW2ic',
  useOldVardenStaticUrls: true,
  recaptchaSiteKey: '6LegSb0aAAAAAMx6oFZJGP1DtfImiNH5DN3NtKfS',
  mailchimp_lid: 'f97484dab2',
  mailchimp_uid: '65f33ede62e0b7c8353677a30',
  googleTagManagerId: 'GTM-WJW5HVR',
  configCatKey: 'TjnYCHffNkSDwHmGMIqeag/S5pDL4CgVUqzSjfTcjddsg',
  configCatLogLvl: 3,
  configCatFrontendPoolInterval: 360,
  authRegion: 'eu-west-1',
  authUserPoolId: 'eu-west-1_adIRdbp6e',
  authClientId: '3sjci66n3igktd3t53i0ejdjaa',
  authDomain: 'varden-dev.auth.eu-west-1.amazoncognito.com',
  listningWidgetLoader: 'https://www.varden.se/varden-scripts/widgets/listadig/dev/widget.loader.js',
  listedWidgetLoader: 'https://www.varden.se/varden-scripts/widgets/listed/dev/widget.loader.js',
  tracesSampleRate: 1.0,
  release: null,
  scraperUseProxy: true,
  sentryDsn: 'https://6be956c2e13d46a3a47393ea6379a652@o1146166.ingest.sentry.io/6214600',
  features: {
    enableCareServicesInMegaMenu: true,
    enableFavsButton: false,
    enableGtmForCypress: true,
    enableSymptomsInMegaMenu: true,
    fakeBankId: false,
    myPages: true,
    showNextMonthTimeslots: true,
    temporaryDisableWidgets: true,
    putTestBookingWidget: true,
    showMailchimpSignup: false,
  },
};
